import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/landlord/pricing_tiers";

export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getPricingTierDetails(id){
    return Repository.get(`${resource}/${id}`)
  },
  createPricingTier(payload){
    return Repository.post(`${resource}`, payload)
  },
  updatePricingTier(id, payload){
    return Repository.put(`${resource}/${id}`, payload)
  },
  statusChangePricingTier(id, status) {
    return Repository.put(`/landlord/pricing_tier/${id}/${status}`)
  },
  getPricingItems() {
    return Repository.get('/landlord/pricing_tier_items')
  },
};
